'use client';

import s from './styles.module.scss';
import React from 'react';
import FancyButton from '@/src/components/ui/FancyButton';
import { useModal } from '@/src/components/ui/ModalProvider';
import { useViewport } from '@/src/lib/useViewport';

const BP = 786;

export const WantFeel = () => {
    const { openModal } = useModal();
    const { mounted, vw, isMobile } = useViewport(BP);

    if (!mounted || vw === null) {
        return <div className={s.root} />;
    }

    return (
        <div className={s.root}>
            <div className={s.content}>
                <h2>
                    Хочеш вiдчути такi
                    <br />ж емоцiї?
                </h2>

                {isMobile ? (
                    <FancyButton
                        normalSvg="/icons/btn_blue.svg"
                        hoverSvg="/icons/btn_blue_active.svg"
                        width={223}
                        height={44}
                        fit="fill"
                        className={s.btn}
                        onClick={openModal}
                    ></FancyButton>
                    ):(
                    <FancyButton
                        normalSvg="/icons/btn_blue.svg"
                        hoverSvg="/icons/btn_blue_active.svg"
                        width={295}
                        height={69}
                        fit="fill"
                        className={s.btn}
                        onClick={openModal}
                    ></FancyButton>
                )}

            </div>
        </div>
    );
};
